if (!customElements.get("deployer-quantity-breaks")) {
  customElements.define(
    "deployer-quantity-breaks",
    class DeployerQuantityBreaks extends HTMLElement {
      constructor() {
        super();
        this.main_product_form =
          this.closest(".js-main-product").querySelector(".product-form") ||
          document.querySelector('.product__page form[action*="/cart/add"]') ||
          document.querySelector('.product form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add.js"]') ||
          document.querySelector('form[action*="/cart/add"]');
        this.main_product_section_id = this.dataset.sectionId;
        this.variant_mode = this.getAttribute("data-variant-mode");
        if (this.main_product_form === null) return console.error("Deployer Quantity Breaks: No product form found");

        // update when variant changes (works with Broadcast, Prestige, Dawn & co, Impulse)
        if (this.main_product_form.querySelector('input[name="id"]') !== null) {
          this.main_product_form.querySelector('input[name="id"]').addEventListener("change", (event) => {
            this.renderDeployerQuantityBreaks(event.target.value);
          });
        } else {
          if (typeof subscribe === "function") {
            this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              this.renderDeployerQuantityBreaks(event.data.variant.id);
            });
          } else {
            document.addEventListener("variant:change", (event) => {
              this.renderDeployerQuantityBreaks(event.detail.variant.id);
            });
          }
        }
      }

      connectedCallback() {
        this.updatePrices();
        this.updateSubWidgetPrices();

        this.updateFormInputs(this.getSelectedQuantity());

        // AJOUT : Écouter les changements de type d'achat (subscription/one-time)
        const subscriptionInputs = document.querySelectorAll('input[name="subscription"]');
        subscriptionInputs.forEach((input) => {
          input.addEventListener("change", () => {
            // Mettre à jour tous les prix quand le type d'achat change
            this.updatePrices();
            this.updateSubWidgetPrices();
          });
        });

        // update when quantity changes
        if (this.variant_mode == "no-variant") {
          this.querySelectorAll(".quantity-break").forEach((quantity_break) => {
            quantity_break.addEventListener("click", () => {
              this.selectQuantity(quantity_break);
              this.updateFormInputs(quantity_break);
              // Mettre à jour les prix des quantity breaks ET du sub widget
              this.updatePrices();
              this.updateSubWidgetPrices();
            });
          });
        } else if (this.variant_mode == "select") {
          // update when variant changes in quantity break
          this.querySelectorAll(".quantity-break").forEach((quantity_break) => {
            quantity_break.addEventListener("click", () => {
              this.selectQuantity(quantity_break);
              setTimeout(() => {
                this.updateFormInputs(quantity_break);
                const variantsSelectedAvailable = Array.from(quantity_break.querySelectorAll("deployer-quantity-break-variant-picker")).every(
                  (fieldset) => fieldset.dataset.available === "true"
                );
                if (variantsSelectedAvailable) {
                  this.toggleAddButton(false, "", false);
                } else {
                  this.toggleAddButton(true, "", false);
                }
                // Mettre à jour les prix des quantity breaks ET du sub widget
                this.updatePrices();
                this.updateSubWidgetPrices();
              });
            });
          });
        } else if (this.variant_mode == "distribution") {
          const blockDistribution = this.querySelector("deployer-quantity-break-distribution");

          // update when variant changes in quantity break
          this.querySelectorAll(".quantity-break").forEach((quantity_break) => {
            quantity_break.addEventListener("click", () => {
              this.selectQuantity(quantity_break);
              blockDistribution.refresh();
              // Mettre à jour les prix des quantity breaks ET du sub widget
              this.updatePrices();
              this.updateSubWidgetPrices();
            });
          });
        }
      }

      updatePrices(discountPercents = null) {
        const subscriptionWidget = document.querySelector("subscription-widget");
        if (!subscriptionWidget) return;

        if (!discountPercents) discountPercents = parseFloat(document.querySelector("subscription-widget.active").dataset.discountPercents);

        const pricesToUpdate = this.querySelectorAll(".quantity-break_price-container_price");

        pricesToUpdate.forEach((price) => {
          const closestQuantityBreak = price.closest(".quantity-break");
          const quantityDiscount = closestQuantityBreak ? parseFloat(closestQuantityBreak.dataset.reductionPercentage) || 0 : 0;
          const purchaseType = document.querySelector('input[name="subscription"]:checked');

          if (purchaseType.id === "subscription-input") {
            // Mode abonnement : réduction d'abonnement + réduction de quantité
            discountPercents = parseFloat(document.querySelector("subscription-widget.active").dataset.discountPercents);
            discountPercents = discountPercents + quantityDiscount;
          } else {
            // Mode achat unique : seulement la réduction de quantité
            discountPercents = quantityDiscount;
          }

          const closestCompareAtPrice = closestQuantityBreak.querySelector(".quantity-break_price-container_compare-at-price");
          const priceCents = closestCompareAtPrice ? parseInt(closestCompareAtPrice.dataset.priceCents) : parseInt(price.dataset.priceCents);
          const quantity = parseInt(price.dataset.quantity);
          const priceToUpdate = this.formatPrice(priceCents, quantity, discountPercents);

          price.innerText = priceToUpdate;

          // NOUVEAU : Mettre à jour le prix unitaire
          const unitPrice = priceCents / quantity;
          const unitPriceToUpdate = this.formatUnitPrice(unitPrice, discountPercents);
          const unitPriceElement = closestQuantityBreak.querySelector(".quantity-break_price-container_unit-price_price");
          if (unitPriceElement) unitPriceElement.innerText = unitPriceToUpdate;
        });

        // NOUVEAU : Mettre à jour les compare-at-price des quantity breaks
        const compareAtPricesToUpdate = this.querySelectorAll(".quantity-break_price-container_compare-at-price");
        const purchaseType = document.querySelector('input[name="subscription"]:checked');
        const isSubscriptionMode = purchaseType && purchaseType.id === "subscription-input";
        const subscriptionDiscountPercents = parseFloat(document.querySelector("subscription-widget.active").dataset.discountPercents);

        compareAtPricesToUpdate.forEach((compareAtPrice) => {
          const closestQuantityBreak = compareAtPrice.closest(".quantity-break");
          const originalPriceCents = parseInt(compareAtPrice.dataset.priceCents);
          const quantity = parseInt(compareAtPrice.dataset.quantity);

          let compareAtDiscountPercents = 0;
          if (isSubscriptionMode) {
            // Mode abonnement : compare-at-price avec seulement la réduction d'abonnement
            compareAtDiscountPercents = subscriptionDiscountPercents;
          }
          // Mode one-time : compare-at-price sans aucune réduction (0%)

          const compareAtPriceFormatted = this.formatPrice(originalPriceCents, quantity, compareAtDiscountPercents);
          compareAtPrice.innerText = compareAtPriceFormatted;
        });

        this.updateCTAPrice(this.getSelectedQuantity());
      }

      updateSubWidgetPrices() {
        const selectedQuantityBreak = this.getSelectedQuantity();
        this.updateCTAPrice(selectedQuantityBreak);

        // Utiliser EXACTEMENT la même logique que updatePrices
        const selectedQuantityBreakCompareAtPrice = selectedQuantityBreak.querySelector(".quantity-break_price-container_compare-at-price");
        const selectedQuantityBreakPrice = selectedQuantityBreak.querySelector(".quantity-break_price-container_price");

        // Prix de base : même logique que updatePrices
        const priceCents = selectedQuantityBreakCompareAtPrice
          ? parseInt(selectedQuantityBreakCompareAtPrice.dataset.priceCents)
          : parseInt(selectedQuantityBreakPrice.dataset.priceCents);

        const quantityDiscount = parseFloat(selectedQuantityBreak.dataset.reductionPercentage) || 0;
        const quantity = parseInt(selectedQuantityBreak.dataset.quantity);

        const priceOneTimeElement = document.querySelector(".jc-onetime-input .js-update-price");
        const priceSubscriptionElement = document.querySelector(".jc-subscription-input .js-update-price");
        const subscriptionDiscountPercents = parseFloat(priceSubscriptionElement.closest("subscription-widget").dataset.discountPercents);

        // PRIX FINAUX
        // One-time: prix de base + réduction de quantité seulement
        priceOneTimeElement.innerText = this.formatPrice(priceCents, quantity, quantityDiscount);

        // Subscription: prix de base + réduction de quantité + réduction d'abonnement
        priceSubscriptionElement.innerText = this.formatPrice(priceCents, quantity, subscriptionDiscountPercents + quantityDiscount);

        // COMPARE-AT-PRICE (prix barrés)
        const priceSubscriptionCompareAtPriceElement = document.querySelector(".jc-subscription-input .sub-compare-price");
        const priceOneTimeCompareAtPriceElement = document.querySelector(".js-onetime-compare-at-price");

        if (selectedQuantityBreakCompareAtPrice) {
          // Pour subscription: compare-at-price avec seulement la réduction d'abonnement (pas la quantité)
          priceSubscriptionCompareAtPriceElement.classList.remove("hidden");
          priceSubscriptionCompareAtPriceElement.innerText = this.formatPrice(
            parseInt(selectedQuantityBreakCompareAtPrice.dataset.priceCents),
            quantity,
            subscriptionDiscountPercents // Seulement la réduction d'abonnement
          );

          // Pour one-time: compare-at-price sans aucune réduction (prix original)
          priceOneTimeCompareAtPriceElement.classList.remove("hidden");
          priceOneTimeCompareAtPriceElement.innerText = this.formatPrice(
            parseInt(selectedQuantityBreakCompareAtPrice.dataset.priceCents),
            quantity,
            0 // Aucune réduction sur le prix barré
          );
        } else {
          // Pas de compare-at-price à afficher
          priceSubscriptionCompareAtPriceElement.classList.add("hidden");
          priceSubscriptionCompareAtPriceElement.innerText = "";
          priceOneTimeCompareAtPriceElement.classList.add("hidden");
          priceOneTimeCompareAtPriceElement.innerText = "";
        }
      }

      formatPrice(cents, quantity, discountPercents = 0) {
        const unitPrice = cents / quantity;

        const unitPriceReduced = (unitPrice * (1 - discountPercents / 100)).toFixed(2);

        let finalPrice = Math.round(((unitPriceReduced * quantity) / 100) * 10) / 10;
        // End of Selection
        const finalPriceHtml = document.body.dataset.currency + finalPrice.toFixed(2).replace(".", ",");

        return finalPriceHtml;
      }

      formatUnitPrice(cents, discountPercents = 0) {
        const unitPrice = cents;

        const unitPriceReduced = (unitPrice * (1 - discountPercents / 100)).toFixed(2);

        let finalPrice = Math.trunc((unitPriceReduced / 100) * 100) / 100;
        // End of Selection
        const finalPriceHtml = document.body.dataset.currency + finalPrice.toFixed(2).replace(".", ",");

        return finalPriceHtml;
      }

      renderDeployerQuantityBreaks(variant_id) {
        this.classList.add("loading");
        var variant_param = "?variant=" + variant_id + "&";
        if (variant_id === undefined) variant_param = "?";

        fetch(window.location.pathname + variant_param + "section_id=" + this.main_product_section_id)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");

            const deployerQuantityBreaksSource = html.querySelector("deployer-quantity-breaks");
            const deployerQuantityBreaksDestination = this;

            if (deployerQuantityBreaksSource && deployerQuantityBreaksDestination) {
              deployerQuantityBreaksDestination.innerHTML = deployerQuantityBreaksSource.innerHTML;
              deployerQuantityBreaksDestination.connectedCallback();
            }
          })
          .then(() => {
            this.classList.remove("loading");
          });
      }

      selectQuantity(quantity_break) {
        if (quantity_break.classList.contains("disabled-quantity-break")) return;
        this.resetSelectedQuantity();
        quantity_break.classList.add("selected-quantity-break");
      }

      resetSelectedQuantity() {
        this.querySelectorAll(".quantity-break").forEach((quantity_break) => {
          quantity_break.classList.remove("selected-quantity-break");
        });
      }

      updateFormInputs(quantity_break) {
        this.clearFormInputs();
        if (this.variant_mode == "no-variant") {
          if (this.main_product_form.querySelector('jolly-quantity-selector input[name="quantity"]')) {
            this.main_product_form.querySelector('jolly-quantity-selector input[name="quantity"]').value = parseInt(
              quantity_break.getAttribute("data-quantity")
            );
          } else {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "quantity";
            input.value = quantity_break.getAttribute("data-quantity");
            this.main_product_form.appendChild(input);
          }
        } else if (this.variant_mode == "select") {
          const variantsPickers = quantity_break.querySelectorAll("deployer-quantity-break-variant-picker");
          if (variantsPickers.length > 0) {
            variantsPickers.forEach((variantsPicker, index) => {
              if (index === 0) {
                this.main_product_form.querySelector('input[name="id"]').value = variantsPicker.dataset.id;
              } else {
                const inputName = `items[${index}][id]`;
                const inputValue = variantsPicker.dataset.id;
                const inputElement = document.createElement("input");
                inputElement.type = "hidden";
                inputElement.name = inputName;
                inputElement.value = inputValue;
                this.main_product_form.appendChild(inputElement);
              }
            });
          }
        }

        this.updateCTAPrice(quantity_break);
      }

      updateCTAPrice(quantity_break) {
        const ctaPrice = quantity_break.querySelector(".quantity-break_price-container_price").innerText;

        // Mettre à jour le prix final du bouton
        document.querySelectorAll(".jc-current-price").forEach((price) => {
          price.innerText = ctaPrice;
        });

        // UTILISER LA MÊME LOGIQUE QUE updateSubWidgetPrices pour le compare-at-price
        const quantityBreakCompareAtPrice = quantity_break.querySelector(".quantity-break_price-container_compare-at-price");
        const quantityBreakPrice = quantity_break.querySelector(".quantity-break_price-container_price");

        if (quantityBreakCompareAtPrice) {
          const priceCents = quantityBreakCompareAtPrice
            ? parseInt(quantityBreakCompareAtPrice.dataset.priceCents)
            : parseInt(quantityBreakPrice.dataset.priceCents);

          const quantity = parseInt(quantityBreakPrice.dataset.quantity);

          // Vérifier le mode d'achat actuel
          const purchaseType = document.querySelector('input[name="subscription"]:checked');
          const isSubscriptionMode = purchaseType && purchaseType.id === "subscription-input";

          // TOUS les éléments de compare-at-price du bouton
          const allCompareAtPriceElements = document.querySelectorAll(".js-onetime-compare-at-price, .sub-compare-price, .subscription__original-price");

          if (isSubscriptionMode) {
            // Mode subscription : compare-at-price avec seulement la réduction d'abonnement
            const subscriptionDiscountPercents = parseFloat(document.querySelector("subscription-widget.active").dataset.discountPercents);
            const subscriptionCompareAtPriceFormatted = this.formatPrice(priceCents, quantity, subscriptionDiscountPercents);

            allCompareAtPriceElements.forEach((element) => {
              element.classList.remove("hidden");
              element.innerText = subscriptionCompareAtPriceFormatted;
            });
          } else {
            // Mode one-time : compare-at-price prix original sans aucune réduction
            const oneTimeCompareAtPriceFormatted = this.formatPrice(priceCents, quantity, 0);

            allCompareAtPriceElements.forEach((element) => {
              element.classList.remove("hidden");
              element.innerText = oneTimeCompareAtPriceFormatted;
            });
          }
        } else {
          // Pas de compare-at-price à afficher
          const allCompareAtPriceElements = document.querySelectorAll(".js-onetime-compare-at-price, .sub-compare-price, .subscription__original-price");
          allCompareAtPriceElements.forEach((element) => {
            element.classList.add("hidden");
            element.innerText = "";
          });
        }
      }

      clearFormInputs() {
        // remove all the inputs in the form that the name starts with "items"
        const inputs = this.main_product_form.querySelectorAll('input[name^="items"]');
        inputs.forEach((input) => {
          this.main_product_form.removeChild(input);
        });
      }

      getSelectedQuantity() {
        return this.querySelector(".selected-quantity-break");
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.main_product_form;
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.deployerAdapter.addToCartText;
        }
        if (!modifyClass) return;
      }
    }
  );
}

if (!customElements.get("deployer-quantity-break-distribution")) {
  customElements.define(
    "deployer-quantity-break-distribution",
    class QuantityBreakDistributionBlock extends HTMLElement {
      constructor() {
        super();
        this.quantity_break = this.closest("deployer-quantity-breaks");
      }

      connectedCallback() {
        this.refresh();

        // Gestion des sélecteurs de quantité
        this.querySelectorAll(".quantity-break_distribution-variant-quantity-wrapper").forEach((quantity_wrapper) => {
          const quantity_add_button = quantity_wrapper.querySelector(".quantity-break_distribution-variant-add-button");
          const quantity_selector = quantity_wrapper.querySelector(".deployer-quantity");
          const quantity_input = quantity_selector.querySelector("input");

          quantity_add_button.addEventListener("click", (event) => {
            event.preventDefault();
            quantity_input.stepUp();
            quantity_add_button.classList.add("hidden");
            quantity_selector.classList.remove("hidden");
            this.refresh();
          });

          quantity_selector.querySelectorAll("button").forEach((button) => {
            button.addEventListener("click", (event) => {
              event.preventDefault();
              if (!button.disable) {
                if (event.target.name === "plus" && this.getNumberOfSelectedVariants() < this.quantity_break.getSelectedQuantity().dataset.quantity)
                  quantity_input.stepUp();
                if (event.target.name === "minus") quantity_input.stepDown();
                this.refresh();
              }
            });
          });
        });
      }

      refresh() {
        //Update the button state if not all the variants are selected
        if (this.getNumberOfSelectedVariants() < this.quantity_break.getSelectedQuantity().dataset.quantity) {
          this.quantity_break.toggleAddButton(true, "", false);
        } else {
          this.quantity_break.toggleAddButton(false, "", false);
        }

        //Update the quantity button add state if all variants are selected
        document.querySelectorAll(".quantity-break_distribution-variant-quantity-wrapper").forEach((quantity_wrapper) => {
          const quantity_button_add = quantity_wrapper.querySelector(".quantity-break_distribution-variant-add-button");
          if (parseInt(this.getNumberOfSelectedVariants()) === parseInt(this.quantity_break.getSelectedQuantity().dataset.quantity)) {
            quantity_button_add.disabled = true;
          } else {
            quantity_button_add.disabled = false;
          }
        });

        //Reset quantity selectors if too much variants are selected
        if (this.getNumberOfSelectedVariants() > this.quantity_break.getSelectedQuantity().dataset.quantity) {
          this.resetQuantitySelectors();
          this.quantity_break.toggleAddButton(true, "", false);
        }

        //Update the number of selected variants text
        this.setNumberOfSelectedVariantsText();

        //Update the form inputs
        this.updateFormInputs();

        //Update quantity selector buttons state based on input min and max value
        this.querySelectorAll(".quantity-break_distribution-variant-quantity-wrapper").forEach((quantity_wrapper) => {
          this.updateQuantitySelectorsState(quantity_wrapper);
        });
      }

      updateQuantitySelectorsState(quantity_wrapper) {
        const quantity_selector = quantity_wrapper.querySelector(".deployer-quantity");
        const quantity_input = quantity_selector.querySelector("input");
        const quantity_button_plus = quantity_selector.querySelector('button[name="plus"]');
        const quantity_button_minus = quantity_selector.querySelector('button[name="minus"]');
        const quantity_button_add = quantity_wrapper.querySelector(".quantity-break_distribution-variant-add-button");

        if (quantity_input.max != 0) {
          if (quantity_input.value == quantity_input.min) {
            quantity_button_plus.removeAttribute("disabled");
            quantity_button_minus.setAttribute("disabled", "disabled");
            quantity_button_add.classList.remove("hidden");
            quantity_selector.classList.add("hidden");
          }

          if (quantity_input.value == quantity_input.max) {
            quantity_button_plus.setAttribute("disabled", "disabled");
            quantity_button_minus.removeAttribute("disabled");
            quantity_button_add.classList.add("hidden");
            quantity_selector.classList.remove("hidden");
          }

          if (quantity_input.value > quantity_input.min && quantity_input.value < quantity_input.max) {
            quantity_button_plus.removeAttribute("disabled");
            quantity_button_minus.removeAttribute("disabled");
            quantity_button_add.classList.add("hidden");
            quantity_selector.classList.remove("hidden");
          }
        } else {
          quantity_button_add.disabled = true;
        }
      }

      resetQuantitySelectors() {
        this.querySelectorAll(".quantity-break_distribution-variant-quantity-wrapper").forEach((quantity_wrapper) => {
          quantity_wrapper.querySelectorAll(".deployer-quantity").forEach((quantity_selector) => {
            quantity_selector.querySelector("input").value = 0;
            quantity_selector.classList.add("hidden");
          });
          const quantity_button_add = quantity_wrapper.querySelector(".quantity-break_distribution-variant-add-button");
          quantity_button_add.classList.remove("hidden");
        });
      }

      getNumberOfSelectedVariants() {
        var currentNumberOfSelectedVariants = 0;
        this.querySelectorAll(".deployer-quantity").forEach((quantity_selector) => {
          const quantity_input = quantity_selector.querySelector("input");
          currentNumberOfSelectedVariants += parseInt(quantity_input.value);
        });
        return currentNumberOfSelectedVariants;
      }

      setNumberOfSelectedVariantsText() {
        this.querySelector(".quantity-break_distribution-header-quantity-selected").innerHTML =
          this.getNumberOfSelectedVariants() + "/" + this.quantity_break.getSelectedQuantity().dataset.quantity;
      }

      updateFormInputs() {
        this.clearFormInputs();
        // Add a quantity and variant id input to form for each selected variant
        var index = 0;
        this.querySelectorAll(".quantity-break_distribution-variant").forEach((variant) => {
          const quantity_input = variant.querySelector(".deployer-quantity input").value;
          if (quantity_input > 0) {
            index++;
            const variantInput = document.createElement("input");
            variantInput.type = "hidden";
            variantInput.name = `items[${index}][id]`;
            variantInput.value = variant.dataset.variantId;
            this.quantity_break.main_product_form.appendChild(variantInput);

            const quantityInput = document.createElement("input");
            quantityInput.type = "hidden";
            quantityInput.name = `items[${index}][quantity]`;
            quantityInput.value = quantity_input;
            this.quantity_break.main_product_form.appendChild(quantityInput);
          }
        });
      }

      clearFormInputs() {
        this.quantity_break.clearFormInputs();
        this.quantity_break.main_product_form.querySelectorAll('input[name="id"]').forEach((input) => {
          this.quantity_break.main_product_form.removeChild(input);
        });
      }
    }
  );
}

if (!customElements.get("deployer-quantity-break-variant-picker")) {
  customElements.define(
    "deployer-quantity-break-variant-picker",
    class QuantityBreakVariantPicker extends HTMLElement {
      constructor() {
        super();
        this.DeployerQuantityBreaks = this.closest("deployer-quantity-breaks");
        this.inputs = this.querySelectorAll('input[type="radio"]');
        this.selects = this.querySelectorAll("select");
        this.optionsNames = this.querySelectorAll("legend span");
        this.options = [];
        this.currentVariant = this.dataset.id;
        this.variantData = JSON.parse(this.DeployerQuantityBreaks.querySelector('[type="application/json"]').textContent);
      }

      connectedCallback() {
        this.updateOptions();
        this.updateVariantStatuses();
        this.inputs.forEach((input) => {
          input.addEventListener("change", (event) => {
            this.onChange(event);
          });
        });
        this.selects.forEach((select) => {
          select.addEventListener("change", (event) => {
            this.onChange(event);
          });
        });
      }

      onChange(event) {
        this.updateOptions();
        this.updateDataId();
        this.updateOptionsNames();
        this.updateVariantStatuses();
        this.DeployerQuantityBreaks.updateFormInputs(event.target.closest(".quantity-break"));
      }

      updateOptions() {
        this.options = [];
        this.options.push(
          ...Array.from(this.querySelectorAll('input[type="radio"]:checked'), (element) => {
            if (element.tagName === "INPUT") {
              return element.value;
            }
          })
        );
        this.options.push(
          ...Array.from(this.querySelectorAll("select"), (element) => {
            if (element.tagName === "SELECT") {
              return element.value;
            }
          })
        );
      }

      updateDataId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
        this.dataset.id = this.currentVariant.id;
        if (this.currentVariant.available === false) {
          this.dataset.available = "false";
        } else {
          this.dataset.available = "true";
        }
      }

      updateVariantStatuses() {
        const selectedOptions = this.querySelectorAll(":checked");
        const inputWrappers = [...this.querySelectorAll("fieldset")];
        let selectedOptionOneVariants = null;
        let selectedOptionTwoVariants = null;
        let selectedOptionThreeVariants = null;
        if (selectedOptions[0]) {
          selectedOptionOneVariants = this.variantData.filter((variant) => selectedOptions[0].value === variant.option1);
        }
        if (selectedOptions[1]) {
          selectedOptionTwoVariants = this.variantData.filter((variant) => selectedOptions[1].value === variant.option2);
        }
        if (selectedOptions[2]) {
          selectedOptionThreeVariants = this.variantData.filter((variant) => selectedOptions[2].value === variant.option3);
        }
        inputWrappers.forEach((option, index) => {
          if (selectedOptions.length <= 1) return;
          if (index === 0) {
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index + 1].querySelector(":checked").value;
            const availableOptionInputsValue = selectedOptionTwoVariants
              .filter((variant) => variant.available && variant[`option${index + 2}`] === previousOptionSelected)
              .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
          } else {
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
            const availableOptionInputsValue = selectedOptionOneVariants
              .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
              .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
          }
        });
      }

      setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
          const value = element.getAttribute("value");
          const availableElement = availableValuesList.includes(value);

          if (element.tagName === "INPUT") {
            if (availableElement) {
              element.classList.remove("disabled");
            } else {
              element.classList.add("disabled");
            }
          } else if (element.tagName === "OPTION") {
            element.innerText = availableElement ? value : window.deployerAdapter.unavailableText.replace("[value]", value);
          }
        });
      }

      updateOptionsNames() {
        this.optionsNames.forEach((optionName, index) => {
          optionName.innerText = this.options[index];
        });
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.DeployerQuantityBreaks.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
    }
  );
}
